import React from 'react';
import SelectionList from '../../../shared/components/SelectionList';
import SelectionCheckbox from '../SelectionCheckbox';
import useDeviceClassList from '@shared/hooks/useDeviceClassList';

/**
 * @typedef {object} DeviceClassSelectionProps
 * @property {Array<*>} [deviceClasses]
 * @property {(deviceClasses: Array<{ label: string, value: number | string, displayName?: string }>) => void} [setDeviceClasses]
 * @property {boolean} [includeExactMatchedDeviceClasses]
 * @property {(includeExactMatchedDeviceClasses: boolean) => void} [setIncludeExactMatchedDeviceClasses]
 */

/**
 * @param {DeviceClassSelectionProps} props
 */
const DeviceClassSelection = props => {
  const {
    deviceClasses,
    setDeviceClasses,
    includeExactMatchedDeviceClasses,
    setIncludeExactMatchedDeviceClasses
  } = props;

  const { deviceClassList, deviceClassListLoading } = useDeviceClassList();

  return (
    <div className='appraisal-view-customization__section'>
      <SelectionList
        id='select-device-class'
        showInputEndAdornment={false}
        allowAutocomplete={false}
        label='Device Class'
        onSelectHandler={setDeviceClasses}
        selectedValue={deviceClasses}
        list={deviceClassList}
        placeholder='Select a Device Class'
        multiSelect={true}
        loading={deviceClassListLoading}
      />
      <SelectionCheckbox
        id='select-include-exact-device-classes'
        label='Only display results that match the selection exactly.'
        disabled={!deviceClasses.length}
        checked={includeExactMatchedDeviceClasses}
        setChecked={setIncludeExactMatchedDeviceClasses}
      />
    </div>
  );
};

export default DeviceClassSelection;
